/* Copyright (c) 2020-present CloudIO Inc */

import { DataRecord, DBRow, FieldType } from '@cloudio-saas/datasource-types';
import { atom } from '@cloudio-saas/statex';

export interface Column {
  title: string;
  code: string;
  columnName: string;
  index: number;
  dataType: FieldType;
  maxLen: number;
  optional: boolean;
  dateFormat?: string;
}

export interface SuccessResult {
  columns: Record<number, Column>;
  datasourceUid: string;
  sampleRows: DBRow<DataRecord>[];
  uri: string;
  code: number;
  status: 'OK';
  tableName: string;
}

export interface ErrorResult {
  code: number;
  status: 'ERROR';
  message: string;
}

export type Result = SuccessResult | ErrorResult;

export type AcceptFileType = 'csv';

export const sidebarDatasourceUploadFileAtom = atom<AcceptFileType | ''>({
  path: ['transient', 'editMode', 'dsUploadFile'],
  defaultValue: '',
  urlParam: true,
});
